import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nes-container with-title" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Your Staking Account", -1)
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" State: ")
const _hoisted_5 = { class: "inline-block bg-yellow-200" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = { class: "flex mb-5" }
const _hoisted_8 = { class: "flex-1" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs color-slate-400" }, "Use the refresh account button to load the latest reward stats. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FarmerRewardDisplay = _resolveComponent("FarmerRewardDisplay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.parseFarmerState(_ctx.farmerAcc)), 1)
    ]),
    _createElementVNode("div", _hoisted_6, "Total Weedheads staked: " + _toDisplayString(_ctx.farmerAcc.gemsStaked), 1),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_FarmerRewardDisplay, {
          key: _ctx.farmerAcc.rewardB,
          farmReward: _ctx.farmAcc.rewardB,
          reward: _ctx.farmerAcc.rewardB,
          title: ""
        }, null, 8, ["farmReward", "reward"])
      ])
    ]),
    _createElementVNode("button", {
      class: "nes-btn is-primary mb-5",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refreshFarmer && _ctx.refreshFarmer(...args)))
    }, " Refresh account "),
    _hoisted_9
  ]))
}